import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";


const AddCountry = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formdata, setFormData] = useState({
    id: null,
    name: "",
  });

  const saveCountry = () => {
    if (formdata.name) {
      setLoading(true);
      const pUrl = id ? API_URL.COUNTRY_UPDATE : API_URL.COUNTRY_SAVE;
      axios.post(pUrl, formdata).then((res) => {
        setLoading(false);
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", { autoClose: 3000 });
            setTimeout(() => {
              navigate("/country", { replace: true });
            }, 100);
          } else {
            resetForm();
            toast.success("Saved", { autoClose: 3000 });
          }
        }
      }).catch(() => {
        setLoading(false);
        toast.error("An error occurred. Please try again.", {
          autoClose: 3000,
          
        });
      });
    }
  };

  const resetForm = () => {
    setFormData({
      id: null,
      name: "",
    });
  };

  const onEdit = () => {
    axios.post(API_URL.COUNTRY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
        });
      }
    });
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Country</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/country"} className="btn btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>Name*</label>
                  <input
                    type="text"
                    name="name"
                    value={formdata.name}
                    className="form-control"
                    id="name"
                    onChange={(event) => {
                      setFormData({ ...formdata, name: event.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-right">
                <button
                  type="submit"
                  onClick={saveCountry}
                  // disabled={!isValidForm()}
                  className="btn btn-primary"
                >
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Watch color={"white"} height={20} width={20} />
                    </div>
                  ) : (
                    "Save Country"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCountry;
